import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#cb3366",
    },
    secondary: {
      main: "#d91a5f",
    },
    text: {
      primary: "#333",
      secondary: "#9E9E9E",
    },
    custom: {
      black: "#000000",
      white: "#ffffff",
    },
  },
  typography: {
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
  },
});

export default theme;
